import React from "react";
import { View, StyleSheet, Modal } from "react-native";
import CustomText from "../../../components/common/general/CustomText/CustomText";
import CustomSpacing from "../../../components/common/layout/CustomSpacing/CustomSpacing";
import CustomButton from "../../../components/common/general/CustomButton/CustomButton";
import { useFocusTrap } from "../../../hooks/useFocusTrap";

const CursorLeavesWindowModal = ({ visible, onConfirm }) => {
  const { trapRef: modalRef } = useFocusTrap({ visible, onEscape: onConfirm });

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={visible}
      accessibilityViewIsModal={true}
      onRequestClose={onConfirm}>
      <View style={styles.centeredView}>
        <View
          ref={modalRef}
          role="dialog"
          aria-modal={true}
          aria-label="Focus Warning"
          accessibilityLabel="Focus Warning"
          style={styles.modalView}>
          <CustomText
            role="heading"
            aria-level={1}
            accessibilityRole="header"
            text="Stay Focused on Your Assessment"
            size="xxl"
            weight="ultraBold"
            style={{ color: "#101828", textAlign: "center" }}
          />
          <CustomSpacing type="vertical" size="l" />
          <CustomText
            text="Our system has detected that your cursor has left the assessment window multiple times. To ensure the integrity of your test, please keep your cursor inside the assessment window."
            size="l"
            weight="normal"
            style={{ color: "#344054", textAlign: "center" }}
          />
          <CustomSpacing type="vertical" size="l" />
          <CustomText
            role="alert"
            text="Your instructor will be informed of any additional activity outside the test window."
            size="l"
            weight="ultraBold"
            style={{ color: "#344054", textAlign: "center" }}
          />
          <CustomSpacing type="vertical" size="l" />
          <CustomSpacing type="vertical" size="xxl" />
          <View style={styles.buttonBox}>
            <CustomButton
              aria-label="Acknowledge warning"
              accessibilityLabel="Acknowledge warning"
              accessibilityRole="button"
              text="Got it"
              onPress={onConfirm}
              styleType="primary"
              style={styles.exitButton}
              textStyle={{ fontWeight: "700", fontSize: 18, fontFamily: "Inter" }}
            />
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  modalView: {
    borderRadius: 20,
    padding: 40,
    height: "auto",
    maxWidth: 688,
    width: "auto",
    backgroundColor: "white",
  },
  exitButton: {
    padding: 16,
    borderRadius: 8,
  },
  buttonBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    gap: 16,
  },
});

export default CursorLeavesWindowModal;
